module.exports = __webpack_public_path__ + "static/media/pic_xj.699cf137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_xj.jpg
// module id = 1843
// module chunks = 0 1